import { Component, inject, Input, OnInit } from '@angular/core';
import { Tag } from 'primeng/tag';
import { I18nService } from '../../../core/services/i18n.service';

@Component({
  selector: 'sps-activation-status-tag',
  imports: [
    Tag
  ],
  templateUrl: './sps-activation-status-tag.component.html',
})
export class SpsActivationStatusTagComponent implements OnInit {

  i18n = inject(I18nService);

  @Input() active: boolean;

  tagValue: string;
  tagSeverity: 'secondary' | 'success' | 'danger' | 'info' | 'warn' | 'contrast';

  ngOnInit() {
    if (this.active) {
      this.tagValue = this.i18n.i18nLng()['ACTIVE'];
      this.tagSeverity = 'success';
    } else {
      this.tagValue = this.i18n.i18nLng()['INACTIVE'];
      this.tagSeverity = 'secondary';
    }
  }
}
